/**
 * @generated SignedSource<<88e9ba3fe16b550133c4f56ea29a626b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateBuildDialog_repository$data = {
  readonly id: string;
  readonly masterBranch: string;
  readonly name: string;
  readonly owner: string;
  readonly " $fragmentType": "CreateBuildDialog_repository";
};
export type CreateBuildDialog_repository$key = {
  readonly " $data"?: CreateBuildDialog_repository$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateBuildDialog_repository">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateBuildDialog_repository",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "owner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterBranch",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "c4c29aaacda79cd855247ff3873c74f2";

export default node;
